import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import App from "./App";
import { StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { AppContextProvider } from "./context/AppContextProvider";
import theme from "./theme";
import { APIProvider } from "@vis.gl/react-google-maps";

const API_KEY = process.env.REACT_APP_MAPS_LICENCE_KEY;
const RootComponent = () => {
  return (
    <React.StrictMode>
      <APIProvider apiKey={API_KEY} libraries={["marker"]}>
        <AppContextProvider>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <BrowserRouter>
            <StyledEngineProvider injectFirst>
              <ErrorBoundary>
                <ThemeProvider theme={theme}>
                  <App />
                </ThemeProvider>
              </ErrorBoundary>
            </StyledEngineProvider>
          </BrowserRouter>
        </AppContextProvider>
      </APIProvider>
    </React.StrictMode>
  );
};

const root = createRoot(document.getElementById("root"));
root.render(<RootComponent />);
